import { withSize } from 'react-sizeme';
import VideoDescription from '../components/VideoDescription';

export default withSize()(VideoDescription);